import { Tag } from 'antd'
import {
  CheckCircleOutlined,
  CloseCircleOutlined,
  ExclamationCircleOutlined,
  ClockCircleOutlined,
} from '@ant-design/icons'
import { OverallAutoCheckState } from '../../helpers/autoCheckStatus'

export const AutoCheckStatusTag = ({
  state,
}: {
  state: OverallAutoCheckState
}) => {
  switch (state) {
    case 'yes':
      return (
        <Tag color="green" icon={<CheckCircleOutlined />}>
          Auto WD: Yes
        </Tag>
      )
    case 'no':
      return (
        <Tag color="red" icon={<CloseCircleOutlined />}>
          Auto WD: No
        </Tag>
      )
    case 'error':
      return (
        <Tag color="orange" icon={<ExclamationCircleOutlined />}>
          Auto WD: Error
        </Tag>
      )
    case 'pending':
    default:
      return (
        <Tag color="default" icon={<ClockCircleOutlined />}>
          Auto WD: Pending
        </Tag>
      )
  }
}
